module.exports = __webpack_public_path__ + "img/ic_video_photo.e8920b9c.png";